// extracted by mini-css-extract-plugin
export default {"root":"Main-root--E5RG0"};